<template>
  <div>
    <transition name="bounce">
      <ChatButton
        v-if="show"
        class="chat-bubble"
        :types="['primary']"
        :class="{'fab-chat': true, mobile: mobile, 'retention': retention}"
        @click="onFabClick"
        :size="mobile ? 48 : 56"
        style="display:none"
      >
        <img
          :class="fabIconSize"
          src="@/assets/icons/contact.svg"
          :size="mobile ? 22 : 32"
        />
      </ChatButton>
    </transition>
    <div
      v-if="show && unreadMessages"
      class="fab-unread-messages"
      :class="{mobile: mobile}"
    >
      {{ unreadMessagesText }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ChatButton from './ChatButton'

export default {
  name: 'FabChat',
  components: {
    ChatButton
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    retention: {
      type: Boolean,
      default: false
    },
    unreadMessages: {
      type: Number,
      default: 0
    }
  },
  computed: {
    fabIconSize () {
      return this.mobile ? 'twenty-two' : 'thirty-two'
    },
    unreadMessagesText () {
      return this.unreadMessages < 100 ? this.unreadMessages + '' : '99+'
    }
  },
  methods: {
    ...mapActions('conversation', [
      'updateMessagesStatus'
    ]),
    onFabClick () {
      this.$emit('fabClick')
      if (this.unreadMessages > 0) {
        this.updateMessagesStatus()
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.sanchat-wrapper {
  .fab-chat {
    /* Quickfix for R5.13 needs reevaluation with predefined z-index ranges*/
    z-index: 899;
    &.retention {
      z-index: 1001;
    }
  }
  .fab-chat {
    margin: 0 44px 66px 0;
    &.mobile {
      margin: 13px 30px 95px 65px !important;
    }
  }
  .chat-bubble {
    display: flex !important;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: auto;
    right: 16px;
    bottom: 16px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    min-height: auto;
    padding: 0;
    .icon {
      margin: 2px;
    }
    /deep/ .twenty-two svg {
      width: 22px;
      height: 22px;
    }
    /deep/ .thirty-two svg {
      width: 32px;
      height: 32px;
    }
  }
  .chat-bubble:hover {
    background-color: #00765a !important;
  }
  .fab-unread-messages {
    z-index: 998;
    font-size: 14px;
    color: white;
    bottom: 115px;
    right: 50px;
    position: fixed;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d0021b;
    &.mobile {
      bottom: 140px;
      right: 30px;
    }
  }
}
.bounce-enter-active {
  animation: bounce-in .4s;
}
.bounce-leave-active {
  animation: bounce-in .4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
